<div class="filter-menu-panel">
    <!-- A dead end has no level to name or step back to, so the message takes the header slot: it reads as the
         pane describing its own state rather than as another row in the list. -->
    @if (message(); as note) {
        <div class="filter-menu-header filter-menu-header--message">
            <fa-icon [icon]="faTriangleExclamation" class="filter-menu-message-icon" aria-hidden="true" />
            <span>{{ note.key | artemisTranslate: { value: note.value } }}</span>
        </div>
    } @else {
        <div class="filter-menu-header">
            @if (showBack()) {
                <button type="button" class="filter-menu-back" (click)="back.emit()">
                    <fa-icon [icon]="faChevronLeft" aria-hidden="true" />
                    <span>{{ headerKey() | artemisTranslate }}</span>
                </button>
            } @else {
                <span>{{ headerKey() | artemisTranslate }}</span>
            }
        </div>
    }
    <ul class="filter-menu" [class.filter-menu--recovery]="!!message()" role="listbox" [id]="listboxId">
        @for (option of options(); track option.id; let i = $index) {
            <li
                class="filter-menu-item"
                [class.filter-menu-item--literal]="option.action.kind === 'literal'"
                [class.filter-menu-item--single]="!option.description"
                role="option"
                [id]="optionDomId(option.id)"
                [attr.aria-selected]="i === activeIndex()"
                [class.is-active]="i === activeIndex()"
                (click)="optionSelected.emit(i)"
                (mouseenter)="optionHovered.emit(i)"
            >
                <div class="filter-menu-icon shrink-0">
                    <fa-icon [icon]="option.icon" size="lg" class="filter-menu-glyph" [class.filter-menu-glyph--ex]="isExcludeGlyph(option)" aria-hidden="true" />
                </div>
                <div class="filter-menu-content min-w-0">
                    <span class="filter-menu-label">
                        {{ option.label }}
                        @if (option.literal; as literal) {
                            <span class="filter-menu-literal">&ldquo;{{ literal }}&rdquo;</span>
                        }
                    </span>
                    @if (option.description) {
                        <span class="filter-menu-description">{{ option.description }}</span>
                    }
                </div>
                <div class="filter-menu-meta shrink-0">
                    @if (option.hint; as hint) {
                        @let parts = hintParts(hint);
                        <span class="filter-menu-syntax" [class.filter-menu-syntax--ex]="isExcludeHint(hint)"
                            >{{ parts.before }}<span class="hint-placeholder">{{ parts.placeholder }}</span
                            >{{ parts.after }}</span
                        >
                    }
                    @if (i === activeIndex()) {
                        <span class="filter-menu-hint">{{ 'global.search.applyFilterKey' | artemisTranslate }}</span>
                    }
                </div>
            </li>
        } @empty {
            <li class="filter-menu-empty" data-testid="filter-menu-empty">{{ emptyReasonKey() ?? 'global.search.noFilterMatches' | artemisTranslate }}</li>
        }
    </ul>
</div>
